module.exports = __webpack_public_path__ + "school/img/chineseCharacterBg.e6df51bc.jpg";